import { render, staticRenderFns } from "./WarehouseField.vue?vue&type=template&id=187ee00e"
import script from "./WarehouseField.vue?vue&type=script&lang=js"
export * from "./WarehouseField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports